import { QuestionV3ControlTypes } from './enum';
import { QuestionBaseV3 } from './question-base';

export class ImageQuestionV3 extends QuestionBaseV3 {
  controlType = QuestionV3ControlTypes.IMAGE;
  src: string;

  constructor(options: any = {}) {
    super(options);
    this.src = options['src'] || '';
  }
}
